module.exports = __webpack_public_path__ + "img/sj.e8e08450.png";